var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00ACC1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.52 491.52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 235.52,
    width: 20.48,
    height: 40.96
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 133.118,
    y: 27.429,
    transform: "matrix(0.866 -0.5 0.5 0.866 -4.7472 78.1026)",
    width: 20.48,
    height: 40.96
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.151,
    y: 102.404,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -72.2251 120.6831)",
    width: 20.48,
    height: 40.96
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.48,
    y: 215.04,
    width: 40.96,
    height: 20.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 47.912,
    y: 317.445,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -154.6568 78.0769)",
    width: 40.96,
    height: 20.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 412.876,
    y: 307.254,
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -72.2492 530.341)",
    width: 20.48,
    height: 40.96
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 430.08,
    y: 215.04,
    width: 40.96,
    height: 20.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 402.637,
    y: 112.643,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -4.7645 227.9821)",
    width: 40.96,
    height: 20.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 327.681,
    y: 37.676,
    transform: "matrix(0.5 -0.866 0.866 0.5 132.5745 325.4675)",
    width: 40.96,
    height: 20.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M399.36,215.04c0-43.64-18.66-85.36-51.2-114.48c-32.99-29.53-75.61-43.04-119.96-38.14 C158.18,70.2,101.42,126.63,93.24,196.6c-4.2,35.91,3.74,70.77,22.94,100.82c17.528,27.432,30.226,58.44,38.146,91.7H122.88v20.48 h35.651c1.166,6.753,2.158,13.571,2.929,20.48H133.12v20.48h30.08c0.354,6.594,0.64,13.211,0.64,19.91v21.05h163.84v-25.39 c0-5.191,0.297-10.381,0.566-15.57H358.4v-20.48h-28.378c0.819-6.833,1.883-13.659,3.167-20.48h35.451v-20.48h-30.889 c8.321-32.402,21.684-64.591,40.399-96.27C392.02,269.35,399.36,242.45,399.36,215.04z M307.2,466.13v4.91H184.32v-0.57 c0-6.698-0.307-13.309-0.644-19.91h124.087C307.512,455.749,307.2,460.938,307.2,466.13z M309.429,430.08H182.023 c-0.727-6.899-1.644-13.721-2.743-20.48h133.101C311.179,416.419,310.197,423.246,309.429,430.08z M316.626,389.12H175.371 c-8.329-37.288-22.327-72.045-41.931-102.72c-16.63-26.03-23.5-56.26-19.86-87.42c7.09-60.6,56.24-109.47,116.88-116.2 c38.57-4.28,75.46,7.45,104.04,33.04c28.21,25.24,44.38,61.4,44.38,99.22c0,23.75-6.35,47.05-18.37,67.39 C339.828,317.449,325.287,353.134,316.626,389.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "302.15,169.91 287.67,184.39 323.44,220.16 287.67,255.93 302.15,270.41 352.4,220.16 "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "203.85,184.39 189.37,169.91 139.12,220.16 189.37,270.41 203.85,255.93 168.08,220.16 "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 172.685,
    y: 209.919,
    transform: "matrix(0.3419 -0.9397 0.9397 0.3419 -45.3349 375.5717)",
    width: 145.593,
    height: 20.47
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/Idea.e87c4807485c7cb6ce0fe87a251dbf6b.svg";
export { ForwardRef as ReactComponent };